import IComp from '@/models/Comp';
import IFormFieldRules from '@/models/form-field/IFormFieldRules';
import { Mutations, store } from '@/store';
import FieldRulesManager from './FieldRulesManager';

/**
 * Manages comp translations (aka. applying field rules). Often delegates to the FieldRulesManager.
 */
export default {
    /**
     * Run field rules on the given comp.
     * @param comp
     * @param excludeNoValueAndNoSourceInitial
     */
    async run(comp: IComp, excludeNoValueAndNoSourceInitial: boolean): Promise<void> {
        if (comp.sourceData) {
            const submitFieldRules = FieldRulesManager.buildFromComp(comp, excludeNoValueAndNoSourceInitial);
            await runFieldRulesAndUpdateComp(comp, submitFieldRules);
        }
    },

    /**
     * Run field rules on a field identified by the given comp and fieldId.
     * @param comp
     * @param fieldId
     */
    async runOnField(comp: IComp, fieldId: number): Promise<void> {
        if (comp.sourceData) {
            const submitFieldRules = FieldRulesManager.buildFromCompForField(comp, fieldId);
            await runFieldRulesAndUpdateComp(comp, submitFieldRules);
        }
    },
};

async function runFieldRulesAndUpdateComp(comp: IComp, fieldRules: IFormFieldRules): Promise<void> {
    if (fieldRules.length > 0) {
        //console.log(`CompTranslationsManager.runOnField(Action), address[${CompAddressUtils.getShortDescription(comp.address)}], Submitting[${JSON.stringify(submitFieldRules)}]`);

        const resultFieldRules = await FieldRulesManager.runFieldRulesForComp(comp.address, fieldRules);
        if (resultFieldRules) {
            updateCompData(comp, resultFieldRules);
        }
    }
}

function updateCompData(comp: IComp, fieldRules: IFormFieldRules) {
    if (fieldRules) {
        const updates: any[] = [];
        for (const fieldRule of fieldRules) {
            if (comp.sourceData?.some((compData) => compData.fieldId === fieldRule.fieldId)) {
                updates.push({
                    fieldId: fieldRule.fieldId,
                    value: fieldRule.value,
                    fieldRulesApplied: fieldRule.fieldRulesApplied,
                });
            }
        }

        if (updates.length > 0) {
            store.commit(Mutations.CompAddressesV36.UpsertCompSourceDataBatchByFieldId, {
                comp: comp,
                updates: updates,
                description: 'CompTranslationsManager.updateCompData()',
            });
        }
    }
}
